import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { IonContent } from '@ionic/angular';
import { BonusService } from 'src/app/services/bonus/bonus.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { Navigator } from "src/app/components/menu/navigator";
import { EventsService } from 'src/app/services/event/event.service';
import { AccountBalanceService } from 'src/app/services/balance/account-balance.service';
import { GlobalErrorHandlerService } from 'src/app/services/global-errors/global-error-handler.service';

@Component({
  selector: 'app-redeem-refferer-code',
  templateUrl: './redeem-refferer-code.component.html',
  styleUrls: ['./redeem-refferer-code.component.scss'],
})
export class RedeemReffererCodeComponent implements OnInit {
  @ViewChild(IonContent) content: IonContent;

  public error = null;

  public redeemForm: FormGroup;

  public referrer_code: AbstractControl;

  constructor(
    private successMessageService: SuccessMessageService,
    private utils: UtilsService,
    private bonusService: BonusService,
    private navigator: Navigator,
    private events: EventsService,
    private globalErrorHandler: GlobalErrorHandlerService,
    private balanceService: AccountBalanceService
  ) {
    this.successMessageService.clearMessage();
    this.error = null;
  }

  ngOnInit() {

    this.redeemForm = new FormGroup(
      {
        referrer_code: new FormControl('', [Validators.required]),
      }
    );
    this.referrer_code = this.redeemForm.get('referrer_code');

    this.balanceService.updateBalance();

  }

  onInputChange(target) {
  }

  onSubmit() {
    this.error = null;
    this.successMessageService.clearMessage();
    this.bonusService.callReffererBonus(this.redeemForm.get("referrer_code").value).subscribe(
      (response: any) => {

        if (response && !!response.result) {
          this.referrer_code.setValue('');
          this.referrer_code.markAsPristine();

          this.successMessageService.setMessage('Your code was redeemed.');

          this.content.scrollToTop();
        }
        // this.bannerProvider.fetchAllBanners();
      },
      (error) => {
        this.globalErrorHandler.setErrorCode(error.getErrorCode().toUpperCase());

        switch (error.getErrorCode().toUpperCase()) {
          case 'WRONG_BONUS_CODE':
            error.setErrorMessage('The bonus code is wrong or expired, please try another one.');
            break;
          case 'REQUEST_VALIDATION_ERROR':
            error.setErrorMessage(error.getErrorMessage() || 'The bonus code is wrong or expired, please try another one.');
            break;
          case 'INVALID_CODE':
            error.setErrorMessage('The bonus code is wrong or expired, please try another one.');
            break;
          case 'PLAYER_MAX_TIME_REGISTERED':
            error.setErrorMessage("Your account is no longer eligible for the refer a friend program.");
            break;
          case 'CODE_DOES_NOT_EXIST':
            error.setErrorMessage("The code you entered is invalid.");
            break;
          case 'INVALID_CODE':
            error.setErrorMessage("The code you entered is invalid.");
            break;
          case 'PLAYER_ALREADY_REFERRED':
            error.setErrorMessage("Your account has already participated in the refer a friend program.");
            break;
          default:
            error.setErrorMessage(error.error_payload || "Something went wrong.");
            break;
        }
        this.error = error;
        this.content.scrollToTop();
      }
    );
  }
}
